import { registerErrorAction } from '@/lib/errorActions';
import { QuickPlybookAssign } from './QuickPlybookAssign';
import { QuickMoldAssign } from './QuickMoldAssign';

export { QuickPlybookAssign } from './QuickPlybookAssign';
export { QuickMoldAssign } from './QuickMoldAssign';

registerErrorAction({
  id: 'plybook-required',
  patterns: ['P0001', 'plybook', 'plybook asignado', 'plybook required'],
  title: 'Plybook Requerido',
  description: 'Esta OT necesita un plybook para iniciar producción',
  actionLabel: 'Asignar Plybook',
  component: QuickPlybookAssign,
});

registerErrorAction({
  id: 'mold-required',
  patterns: ['molde', 'mold required', 'mold_required', 'sin molde'],
  title: 'Molde Requerido',
  description: 'Esta OT necesita un molde asignado',
  actionLabel: 'Asignar Molde',
  component: QuickMoldAssign,
});
